import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"
import _imports_0 from '@/static/logos/bellalite_black.svg'
import _imports_1 from '@/static/logos/bellalite_white.svg'
import _imports_2 from '../../static/icons/person_icon.svg'
import _imports_3 from '../../static/icons/person_black_icon.svg'
import _imports_4 from '../../static/icons/cart_icon.svg'
import _imports_5 from '../../static/icons/cart_black_icon.svg'
import _imports_6 from '@/static/icons/chevron_down_icon.svg'


const _hoisted_1 = { class: "desktop-header__top-bar" }
const _hoisted_2 = { class: "desktop-header__top-bar-container" }
const _hoisted_3 = { class: "desktop-header__content-left" }
const _hoisted_4 = {
  key: 0,
  class: "desktop-header__logo",
  src: _imports_0,
  alt: "Bellalite black logo"
}
const _hoisted_5 = {
  key: 1,
  class: "desktop-header__logo",
  src: _imports_1,
  alt: "Bellalite white logo"
}
const _hoisted_6 = { class: "desktop-header__slogan" }
const _hoisted_7 = { class: "desktop-header__content-right" }
const _hoisted_8 = {
  key: 0,
  class: "desktop-header__person-icon",
  src: _imports_2
}
const _hoisted_9 = {
  key: 1,
  class: "desktop-header__person-icon",
  src: _imports_3
}
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 0,
  class: "desktop-header__cart-button-count"
}
const _hoisted_12 = {
  key: 1,
  class: "desktop-header__cart-icon",
  src: _imports_4
}
const _hoisted_13 = {
  key: 2,
  class: "desktop-header__cart-icon",
  src: _imports_5
}
const _hoisted_14 = { class: "desktop-header__cart-text" }
const _hoisted_15 = { class: "desktop-header__bottom" }
const _hoisted_16 = { class: "desktop-header__site-navigation" }
const _hoisted_17 = {
  key: 0,
  tabindex: "0",
  class: "desktop-header__site-navigation-item"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  class: "desktop-header__site-navigation-icon",
  src: _imports_6,
  alt: "chevron down"
}, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "desktop-header__cart-button-count"
}
const _hoisted_20 = {
  key: 1,
  class: "desktop-header__cart-icon",
  src: _imports_4
}
const _hoisted_21 = {
  key: 2,
  class: "desktop-header__cart-icon",
  src: _imports_5
}
const _hoisted_22 = { class: "desktop-header__cart-text" }

import { inject, ref, computed } from 'vue';
import useUser from '@/composables/useUser';
import useContext from '@/composables/useContext';
import useScrollIntent from '@/composables/useScrollIntent';
import { channelKey, isNavigationOpenKey, cartKey } from '@/keys';
import NavigationDesktop from '@/components/NavigationDesktop';
import SearchViewInput from '@/components/SearchView/SearchViewInput.vue';
import { unregisterModalKey } from '@/composables/useModals';


export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopHeader',
  setup(__props) {

const {
  settings, texts, mitt, environmentOptions, resolveLink,
} = useContext();
const { user } = useUser();
const isNavigationOpen = inject(isNavigationOpenKey, ref(false));
const channel = inject(channelKey, ref());
const cart = inject(cartKey);
const unregisterModal = inject(unregisterModalKey);
const { siteId } = environmentOptions;

const cartItemCount = computed(() => (cart?.value?.rows || []).reduce((acc, curr) => acc + +curr.quantity, 0));

const rootPath = computed(() => channel.value?.rootPath);
const rootCategory = computed(() => channel.value?.rootProductsCategory || {});
const isScrolled = ref(false);

useScrollIntent(isScrolled);

const myPagesText = computed(() => (user.value.isAuthenticated
  ? user.value?.organization?.organizationName
  : texts('login__submit')));

const toggleMenu = () => {
  isNavigationOpen.value = !isNavigationOpen.value;
};

const openMyPages = () => {
  unregisterModal('SearchView');
  isNavigationOpen.value = false;

  setTimeout(() => {
    mitt.emit('openMyPages');
  }, 0);
};

const openQuickCart = () => {
  unregisterModal('SearchView');
  isNavigationOpen.value = false;

  setTimeout(() => {
    mitt.emit('openQuickCart');
  }, 0);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["desktop-header", { 'desktop-header--scrolled': isScrolled.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(siteId))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: _unref(rootPath),
                class: "desktop-header__logo-container"
              }, {
                default: _withCtx(() => [
                  (_unref(siteId) === 'black')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                    : _createCommentVNode("", true),
                  (_unref(siteId) === 'white')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(settings)?.tagline), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "desktop-header__my-pages",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openMyPages()))
          }, [
            (_unref(siteId) === 'black')
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : _createCommentVNode("", true),
            (_unref(siteId) === 'white')
              ? (_openBlock(), _createElementBlock("img", _hoisted_9))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: "desktop-header__my-pages-text",
              title: _unref(myPagesText)
            }, _toDisplayString(_unref(myPagesText)), 9, _hoisted_10)
          ]),
          _createElementVNode("div", {
            class: "desktop-header__cart",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openQuickCart()))
          }, [
            (_unref(cartItemCount))
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(cartItemCount)), 1))
              : _createCommentVNode("", true),
            (_unref(siteId) === 'black')
              ? (_openBlock(), _createElementBlock("img", _hoisted_12))
              : _createCommentVNode("", true),
            (_unref(siteId) === 'white')
              ? (_openBlock(), _createElementBlock("img", _hoisted_13))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(texts)('header__basket')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", {
        class: _normalizeClass(["desktop-header__bottom-container", { 'desktop-header__bottom-container--scrolled': isScrolled.value }])
      }, [
        _createElementVNode("ul", _hoisted_16, [
          (_unref(rootCategory).name)
            ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (toggleMenu()), ["prevent"])),
                  class: _normalizeClass(["desktop-header__site-navigation-link desktop-header__site-navigation-button", {
                'desktop-header__site-navigation-link--selected':
                  _unref(isNavigationOpen),
              }])
                }, [
                  _createTextVNode(_toDisplayString(_unref(rootCategory).name) + " ", 1),
                  _hoisted_18
                ], 2)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settings)?.mainMenu, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item._uid,
              class: "desktop-header__site-navigation-item"
            }, [
              _createVNode(_component_router_link, {
                to: _unref(resolveLink)(()=> item.link)?.url,
                class: "desktop-header__site-navigation-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["desktop-header__search-bar", { 'desktop-header__search-bar--scrolled': isScrolled.value }])
        }, [
          _createVNode(SearchViewInput, { class: "desktop-header__search-input" })
        ], 2),
        (isScrolled.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["desktop-header__cart", { 'desktop-header__cart--scrolled': isScrolled.value }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (openQuickCart()))
            }, [
              (_unref(cartItemCount))
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(cartItemCount)), 1))
                : _createCommentVNode("", true),
              (_unref(siteId) === 'black')
                ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                : _createCommentVNode("", true),
              (_unref(siteId) === 'white')
                ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(texts)('header__basket')), 1)
            ], 2))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_unref(NavigationDesktop))
  ], 2))
}
}

})